'use client';

import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useContext } from 'react';
import { i18nContext } from '../providers/i18nProvider';
import { getLocales } from '../service';

export function useLocale() {
  const context = useContext(i18nContext);
  if (!context)
    throw new Error('useLocale must be used within an I18NProvider');

  const {
    data: locales,
    error,
    isLoading,
  } = useQuery({
    queryKey: [`locales`],
    queryFn: async () => await getLocales(),
  });

  let pathname = usePathname() ?? '/';
  const pathnameWithoutLocale = () => {
    if (!locales) return pathname;

    const pathnamesArray = pathname.split('/');
    locales.forEach((locale) => {
      if (pathnamesArray[1] === `${locale.locale}`) {
        pathname = pathname.replace(`/${locale.locale}`, '');
      }
    });
    if (pathname === '') pathname = '/';
    return pathname;
  };

  return {
    ...context,
    locales,
    error,
    isLoading,
    pathnameWithoutLocale: pathnameWithoutLocale(),
  };
}
